import ImmutableModel from '../immutable.model';

/**
 * A generic location area such as "Pääkaupunkiseutu".
 */
class LocationArea extends ImmutableModel {
  /**
   * @param {Number} id
   * @param {Number} order
   * @param {String} name
   */
  constructor(id, order, name) {
    super();

    this.id = id;
    this.order = order;
    this.name = name;
  }

  copy() {
    return new LocationArea(
      this.id,
      this.order,
      this.name
    );
  }
}

export default LocationArea;
